enum NavigationVariantType {
  'None',
  'Basic',
  'Mega',
}

export default NavigationVariantType;
